export default __webpack_public_path__ + "static/media/phoenix-send-enabled-icon.24ce44b9.svg";